<template>
	<div id="modalDelSubUserBySupplier" class="modal fade">
		<div class="modal-dialog modal-sm" role="document">
			<div class="modal-content bd-0 tx-14">
				<modal-loading :show="loading"></modal-loading>
				<div class="modal-content bd-0 tx-14">
					<div class="modal-header pd-x-20">
						<h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{$t("subuser.删除子账号")}}</h6>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>	
					<div class="modal-body pd-20">
						<p>{{$t("subuser.删除子账号")}}<strong class="text-danger bold pd-l-5 pd-r-5">{{del_name}}</strong>{{$t("subuser.后不能恢复！确定要删除吗？")}}</p>
					</div>
					<div class="modal-footer justify-content-center">
						<button type="button" class="btn btn-danger tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" @click="del()">{{$t("subuser.删除")}}</button>
						<button type="button" class="btn btn-secondary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" data-dismiss="modal">{{$t("subuser.取消")}}</button>	
					</div>
				</div>	
			</div>	
		</div>
	</div>
</template>

<script>
export default {
	props: ['id', 'del_name'],
	data(){
	    return {
	      loading: false,
	    }
	},
	methods: {
		del() {
			let vm = this;
			if (!this.isSysRights("SubUser.deleteByUser")) return false;
      		vm.loading = true;
			let delOK = () => {
	        	$("#modalDelSubUserBySupplier").modal("hide");
	        	vm.$parent.getSubuserList();
			}
			$.api_call("api.SubUser.deleteByUser",{
      			id: vm.id
	      	},(r) => {
		        vm.loading = false;
		        if (r.ErrorCode == "9999") {
		          	delOK();
		          	ShowTip(this.$t('subuser.删除子账号成功'), "success");
		        }else{
		          	if (r.ErrorCode == "1002") {
		            	userFailure(this);
		          	} else {
		            	ShowTip(r.Message, "danger");
		          	}
		        }
	      	});
		}
	}
}
</script>

<style>
</style>